import { CategoryNode, CategoryNodes, KeywordNode } from 'components/discover/publications/video-browser/model';
import { FC } from 'react';

import { CategoryList } from './category-list';
import { KeywordList } from './keyword-list';

export type CategoryBrowserProps = Readonly<{
  tree: CategoryNodes;

  activeKeyword: KeywordNode | null;
  activeCategory: CategoryNode | null;

  selectCategoryAndKeyword: (category: CategoryNode, keyword: KeywordNode) => void;

  selectCategory: (category: CategoryNode) => void;
}>;

export const CategoryBrowser: FC<CategoryBrowserProps> = ({
  tree,
  selectCategory,
  selectCategoryAndKeyword,
  activeCategory,
  activeKeyword,
}) => {
  return (
    <CategoryList activeCategory={activeCategory} categories={tree} onSelectCategory={selectCategory}>
      {category => (
        <KeywordList
          key={category.id}
          keywords={category.children}
          activeKeyword={activeKeyword}
          onSelect={keyword => selectCategoryAndKeyword(category, keyword)}
        />
      )}
    </CategoryList>
  );
};
